export default __webpack_public_path__ + "static/media/Group 3238.50f6b27b.svg";